import { AdvertisementVariant } from './Advertisement.types';

export const advertisementSize: Record<
  AdvertisementVariant,
  { width: number; height: number; ImageClassName: string }
> = {
  '248x200': {
    width: 248,
    height: 200,
    ImageClassName: 'max-h-[200px] min-h-[200px] min-w-[248px] max-w-[248px]',
  },
  '248x400': {
    width: 248,
    height: 400,
    ImageClassName: 'max-h-[400px] min-h-[400px] min-w-[248px] max-w-[248px]',
  },
  '744x160': {
    width: 744,
    height: 160,
    ImageClassName: 'max-h-[160px] min-h-[160px] min-w-[744px] max-w-[744px]',
  },
};
